import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/view/Login'
import SwiperView from '@/view/SwiperView'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/login',
      name: 'Login',
      component: Login,
    },
    {
      path: '/',
      name: 'SwiperView',
      component: SwiperView,
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js